import { type AdminReferralCodeListParams, getAdminReferralCodeListQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { search: AdminReferralCodeListParams };

export const referralCodesQuery = ({ search }: QueriesInput) => getAdminReferralCodeListQueryOptions(search);

export const queries = (input: QueriesInput): Array<WarmableQuery> => [referralCodesQuery(input)];
